<form clrForm
      [formGroup]="editNotificationsForm">
  <table class="table" id="positionsTable">
    <thead>
    <tr>
      <th class="left">Position</th>
      <th>Anzahl</th>
      <th class="left">Bezeichnung</th>
      <th class="left">Zeichnungsnummer</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td>{{ editPosition }}<span *ngIf="editPart !== 0">.{{ editPart }}</span></td>
      <td>{{ positions[0].number_of_pieces }}</td>
      <td class="left">
        <b>{{ positions[0].name }}</b>
        <span *ngIf="((!positions[0].description) || (positions[0].description.length > 0))"><br />{{ positions[0].description }}</span>
      </td>
      <td class="left">{{ positions[0].technical_drawing }}</td>
      <td rowspan="5" class="btn-group btn-primary btn-icon">
        <button class="btn btn-sm" (click)="updateNotificationsPosition()" [disabled]="editNotificationsForm.invalid">
          <cds-icon shape="floppy"></cds-icon>
          <span class="clr-icon-title">Speichern</span>
        </button>
      </td>
    </tr>
    <tr *ngIf="positions[0].specification">
      <td colspan="2"></td>
      <td colspan="2" class="left">
        <div class="clr-form-control">
          <label class="clr-control-label">Spezifikation</label>
          <div class="clr-control-container">
            <div class="clr-textarea-wrapper">
              {{ positions[0].specification }}
            </div>
          </div>
        </div>
      </td>
    </tr>
    <tr *ngIf="positions[0].comment_phm">
      <td colspan="2"></td>
      <td colspan="2" class="left">
        <div class="clr-form-control">
          <label class="clr-control-label">Kommentar</label>
          <div class="clr-control-container">
            <div class="clr-textarea-wrapper">
              {{ positions[0].comment_phm }}
            </div>
          </div>
        </div>
      </td>
    </tr>
    <tr *ngIf="positions[0].side_agreements">
      <td colspan="2"></td>
      <td colspan="2" class="left">
        <div class="clr-form-control">
          <label class="clr-control-label">Nebenabreden mit dem Lieferanten:</label>
          <div class="clr-control-container">
            <div class="clr-textarea-wrapper">
              {{ positions[0].side_agreements }}
            </div>
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <td colspan="2"></td>
      <td colspan="2" class="left">
        <div class="clr-form-control">
          <label for="remarks" class="clr-control-label">Leistungsumfang</label>
          <div class="clr-control-container">
            <div class="clr-textarea-wrapper">
              <textarea formControlName="remarks" id="remarks" placeholder="{{ positions[0].remarks }}" cols="140" rows="3" class="clr-textarea" value="{{ positions[0].remarks }}"></textarea>
              <cds-icon class="clr-validate-icon" shape="exclamation-circle"></cds-icon>
            </div>
            <span class="clr-subtext">Dieses Feld erscheint im Dokument unter der Position.</span>
          </div>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</form>

<pre *ngIf="devMode" class="datepicker-output">
    {{ editNotificationsForm.value | json }}
</pre>


